<template>
  <div id="add-project" class="m-b-10">
    <!-- page header component -->
    <div class="bg-white shade py-2 px-3 mb-4" style="margin-top: 15px">
      <h3 style="font-size: 20px">
        <router-link to="/admin/dashboard">
          <i class="bi bi-arrow-left"></i>
        </router-link>
        Tambah Project Baru
      </h3>
    </div>
    <!-- step 1 component -->
    <div class="row">
      <div class="col-md-12">
        <div class="bg-white p-l-20 p-t-10 p-r-20 p-b-20 shade">
          <alert-dynamic-component
            v-if="res == 'berhasil'"
            type="success"
            title="<i class='fbi bi-check-circle'></i> Berhasil!"
            subtitle="Project berhasil ditambahkan."
          />
          <alert-dynamic-component
            v-if="res == 'gagal'"
            type="danger"
            title="<i class='bi bi-x-circle'></i> Gagal!"
            subtitle="Terjadi kesalahan pada saat menambahkan project baru."
          />
          <div class="form-add m-t-10">
            <h4>Step 1 - Detail Project</h4>
            <form action="#" v-on:submit.prevent="saveProject">
              <div class="form-group">
                <label for="nama-project">Nama Project</label>
                <input
                  type="text"
                  name="nama_project"
                  v-model="name"
                  placeholder="Nama Project"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group">
                <label for="alias">Alias</label>
                <input
                  type="text"
                  name="alias"
                  v-model="alias"
                  placeholder="Alias"
                  class="form-control"
                  required
                />
                <span class="text-danger" v-if="is_already_exist">
                  <i class="bi bi-x-circle"></i> Nama alias telah tersedia
                </span>
              </div>
              <div class="form-group">
                <label for="status-project">Versi Aplikasi</label>
                <select
                  name="tipe"
                  id=""
                  v-model="tipe"
                  class="form-control"
                  required
                >
                  <option value="1">KURASI</option>
                  <option value="2">KABAYAN</option>
                  <option value="3">DIGIVLA</option>
                </select>
              </div>
              <div class="form-group">
                <label for="category">Kategori Project</label>
                <select
                  name="category"
                  id=""
                  v-model="category"
                  class="form-control"
                  required
                >
                  <option value="GOVERMENT/PEMDA">GOVERMENT/PEMDA</option>
                  <option value="BRAND">BRAND</option>
                  <option value="BUMN">BUMN</option>
                  <option value="APH">APH</option>
                </select>
              </div>
              <div class="form-group">
                <label for="tier">Tier Project</label>
                <select
                  name="tier"
                  id=""
                  v-model="tier"
                  class="form-control"
                  required
                >
                  <option value="A"> Tier A</option>
                  <option value="B"> Tier B</option>
                  <option value="C"> Tier C</option>
                  <option value="D"> Tier D</option>
                  <option value="E"> Tier E</option>
                  <option value="F"> Tier F</option>
                </select>
              </div>
              <div class="form-group" v-if="tipe == 1">
                <label for="jenis-subscribe">Jenis Subscribe</label>
                <select
                  name="display_tipe"
                  id=""
                  v-model="display_tipe"
                  class="form-control"
                  required
                >
                  <option value="1">Data Media Sosial</option>
                  <option value="2">Data Media Konvensional</option>
                  <option value="3">
                    Data Media Sosial dan Media Konvensional
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label for="limit-keyword">Limit Keyword</label>
                <input
                  type="number"
                  name="keyword_limit"
                  v-model="keyword_limit"
                  value=""
                  class="form-control"
                  placeholder="Limit Keyword"
                  required
                />
              </div>
              <div class="form-group">
                <label for="status-project">Status Project</label>
                <select
                  name="status_project"
                  id=""
                  v-model="status"
                  class="form-control"
                  required
                >
                  <option value="1">Running</option>
                  <option value="2">Trial</option>
                  <option value="3">Pending</option>
                  <option value="4">Development</option>
                  <option value="5">On Premise</option>
                </select>
              </div>
              <div
                v-if="status == 2 || status == 1 || status == 4 || status == 5"
                class="form-group"
              >
                <label for="status-project">Periode Project</label>
                <div
                  id="reportrange"
                  style="
                    background: #fff;
                    cursor: pointer;
                    padding: 5px 10px;
                    border: 1px solid #ccc;
                    border-radius: 5px;
                    width: 100%;
                  "
                >
                  <i class="bi bi-calendar-event m-r-15"></i>&nbsp;
                  <span></span>
                  <i class="bi bi-caret-down-fill"></i>
                </div>
              </div>
              <div class="form-group">
                <label for="logo-project">Logo Project</label>
                <input
                  type="file"
                  @change="previewFile"
                  name=""
                  class="form-control"
                />
              </div>
              <div class="form-group">
                <img
                  v-if="img_path"
                  :src="img_path"
                  alt="Preview"
                  height="100"
                />
              </div>
              <div class="form-group" align="right">
                <router-link
                  to="/admin/dashboard"
                  class="btn btn-danger m-r-5"
                  data-dismiss="modal"
                  >Batal</router-link
                >
                <button
                  type="submit"
                  class="btn btn-success"
                  :disabled="is_already_exist"
                >
                  Selanjutnya
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <floating-loader-component
      key="loading_key"
      v-if="is_loading"
      :text="loading_text"
    />
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.js";
import alert_dynamic from "@/views/components/alert_dynamic.vue";
import floating_loader from "@/views/components/floating_loader.vue";
import notif from "@/assets/js/notif.js";

$.pgNotification = notif;

function initDaterangeFilter() {
  $(function() {
    var start = moment();
    var end = moment().add(30, "days");
    function cb(start, end, def_value) {
      if (def_value != "Custom Range") {
        $("#reportrange span").html(
          start.format("D MMM YYYY 00:00") +
            " - " +
            end.format("D MMM YYYY 23:59")
        );
      } else {
        $("#reportrange span").html(
          start.format("D MMM YYYY HH:mm") +
            " - " +
            end.format("D MMM YYYY HH:mm")
        );
      }
    }
    var dateRange = {};
    dateRange["30 Hari"] = [
      moment().format("D MMM YYYY 00:00"),
      moment()
        .add(30, "days")
        .format("D MMM YYYY 23:59"),
    ];
    dateRange["60 Hari"] = [
      moment().format("D MMM YYYY 00:00"),
      moment()
        .add(60, "days")
        .format("D MMM YYYY 23:59"),
    ];
    dateRange["90 Hari"] = [
      moment().format("D MMM YYYY 00:00"),
      moment()
        .add(90, "days")
        .format("D MMM YYYY 23:59"),
    ];
    $("#reportrange").daterangepicker(
      {
        timePicker: true,
        timePicker24Hour: true,
        showDropdowns: true,
        startDate: start,
        endDate: end,
        ranges: dateRange,
        timePickerIncrement: 10,
        opens: "right",
        drops: "up",
        locale: {
          format: "DD MMM YYYY HH:mm",
        },
      },
      cb
    );
    cb(start, end, "default");
  });
}
export default {
  name: "AddProjectStep1",
  title: "Tambah Project Baru | Online Media Monitoring",
  components: {
    "alert-dynamic-component": alert_dynamic,
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      is_already_exist: false,
      name: "",
      alias: "",
      tipe: 1,
      category: "GOVERMENT/PEMDA",
      tier: "A",
      display_tipe: 3,
      logo: null,
      status: 2,
      keyword_limit: 20,
      periode: "",
      img_path: null,
      file_input: null,
      res: null,
      is_loading: false,
      loading_key: 0,
      loading_text: "Menyimpan Project...",
      id_project: this.$route.query.ref ? this.$route.query.ref : null,
    };
  },
  methods: {
    submitForm: function() {
      let data = {};
      this.is_loading = true;
      this.uploadFile()
        .then((filename) => {
          if (
            this.status == 2 ||
            this.status == 1 ||
            this.status == 4 ||
            this.status == 5
          ) {
            let input_periode = $("#reportrange span").html();
            let periode = input_periode.split(" - ");
            let periode_from = moment(periode[0].trim()).format(
              "YYYY-MM-D HH:mm:ss"
            );
            let periode_to = moment(periode[1].trim()).format(
              "YYYY-MM-D HH:mm:ss"
            );
            data = {
              name: this.name,
              alias: this.alias,
              category: this.category,
              tier: this.tier,
              tipe: parseInt(this.tipe),
              display_tipe: parseInt(this.display_tipe),
              logo: filename,
              status: parseInt(this.status),
              periode_from: periode_from,
              periode_to: periode_to,
              keyword_limit: parseInt(this.keyword_limit),
            };
          } else {
            data = {
              name: this.name,
              alias: this.alias,
              logo: filename,
              tier: this.tier,
              display_tipe: parseInt(this.display_tipe),
              status: parseInt(this.status),
              periode_from: "0000-00-00 00:00:00",
              periode_to: "0000-00-00 00:00:00",
              keyword_limit: parseInt(this.keyword_limit),
            };
          }
          let api = process.env.VUE_APP_API_URL + "project-add";
          this.$http
            .post(api, data)
            .then((response) => {
              if (response.status == 200) {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Project telah ditambahkan ',
                    position: "top-right",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
                let ref_id = encodeURI(btoa(response.data.added));
                this.$router.push({
                  path: "/admin/project/detail",
                  query: { ref: ref_id },
                });
                // this.loading_text = "Membuat users...";
                // this.loading_key++;
                // let inserted_id = response.data.added;
                // if (inserted_id > 0) {
                //   let params = {
                //     nama: "Admin " + data.name,
                //     username: data.alias + ".admin",
                //     password: btoa("monitor123***"),
                //     email: "-",
                //     phone: "",
                //     role: btoa(parseInt(2)),
                //     id_project: inserted_id,
                //   };
                //   this.saveUser(params).then(() => {
                //     params.nama = "Analis " + data.name;
                //     params.username = data.alias + ".analis";
                //     params.password = btoa("user123***");
                //     params.role = btoa(parseInt(3));
                //     this.saveUser(params).then(() => {
                //       this.loading_text = "Proses akan segera selesai...";
                //       this.loading_key++;
                //       this.is_loadig = false;
                //       let ref_id = encodeURI(btoa(params.id_project));
                //       this.$router.push({
                //         path: "/admin/project/step2",
                //         query: { ref: ref_id },
                //       });
                //     });
                //   });
                // }
              }
            })
            .catch((error) => {
              this.is_loading = false;
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> ' +
                    error.response.data.status,
                  position: "top-right",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    previewFile: function(e) {
      let file = e.target.files[0];
      this.file_input = file;
      this.img_path = URL.createObjectURL(file);
    },
    uploadFile: function() {
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("file", this.file_input);
        if (this.file_input == null) {
          resolve(null);
        } else {
          this.loading_text = "Mengunggah gambar...";
          this.loading_key++;
          let api = process.env.VUE_APP_API_URL + "upload";
          this.$http
            .post(api, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              if (response.status == 200) {
                this.logo = response.data.filename;
                resolve(response.data.filename);
              } else {
                reject();
              }
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },
    saveUser: function(params) {
      return new Promise((resolve, reject) => {
        this.loading_text = "Menambahkan User...";
        this.loading_key++;
        let api = process.env.VUE_APP_API_URL + "users-add";
        this.$http
          .post(api, params)
          .then((response) => {
            if (response.status == 200) {
              this.loading_text = "User berhasil ditambahkan...";
              this.loading_key++;
              resolve();
            }
            reject();
          })
          .catch(() => {
            this.is_loading = false;
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-x-circle"></i> <b>Error!</b> Gagal menambahkan user. Silahkan tambahkan user kembali',
                position: "top-right",
                timeout: 5000,
                type: "danger",
              })
              .show();
            this.$router.push({
              path: "/admin/dashboard",
            });
            reject();
          });
      });
    },
    checkAlias: function() {
      this.is_already_exist = false;
      if (this.alias) {
        let api =
          process.env.VUE_APP_API_URL +
          "/check-alias-project?alias=" +
          this.alias;
        this.$http
          .get(api)
          .then((response) => {
            if (response.status == 200) {
              this.is_already_exist = true;
            } else {
              this.is_already_exist = false;
            }
          })
          .catch(() => {
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat melakukan cek alias ',
                position: "top-right",
                timeout: 5000,
                type: "danger",
              })
              .show();
          });
      }
    },
    saveProject: function() {
      if (!this.is_already_exist) {
        this.submitForm();
      }
    },
  },
  watch: {
    status: function() {
      initDaterangeFilter();
    },
    name: function() {
      const temp_name = this.name.split(" ");
      if (temp_name.length <= 2) {
        this.alias = this.name.replace(/ /g, "-").toLowerCase();
      } else {
        const inisial_name = temp_name.map((kata) =>
          kata.charAt(0).toLowerCase()
        );
        this.alias = inisial_name.join("");
      }
    },
    alias: function() {
      this.checkAlias();
    },
  },
  mounted: function() {
    initDaterangeFilter();
  },
};
</script>

<style scoped>
select.form-control {
  -webkit-appearance: button;
  cursor: pointer;
}
</style>
